import styled from '@emotion/styled';

import { useSingleAnalytic } from '@/services/analytics';
import { ERROR_KINDS } from '@/state/layout/moderation';
import ManualReview from './common/ManualReview';
import ViolationModal from './ViolationModal';

interface Props {
    onClose: () => void;
    violationType: 'text' | 'audio';
    violations: string[];
}

const TextP = styled.div`
    width: 100%;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${({ theme }) => theme.colors.black.main};
`;

const ViolationsParagraph = styled.div`
    margin-top: 1rem;
    margin-bottom: 2.4rem;
`;

const VIOLATION_TO_TEXT: Record<string, string> = {
    Hate: 'hate speech',
    SelfHarm: 'self harm',
    Sexual: 'sexual language',
    Violence: 'violence',
};

const join = (arr: string[]) => {
    if (arr.length === 0) {
        return '';
    }

    if (arr.length === 1) {
        return arr[0];
    }
    return arr.slice(0, arr.length - 1).join(', ') + ' and ' + arr[arr.length - 1];
};

export default function ({ onClose, violationType, violations }: Props) {
    const hasTerms = violations.length > 0;
    useSingleAnalytic(mixpanel => mixpanel.track(`${violationType}-moderation`, { event: 'view', violations, hasTerms }));
    const [titleViolationText, messageViolationText] = violationType === 'audio' ? ['Audio', 'an audio'] : ['Text', 'a text'];
    const normalizedViolations = violations.map(category => VIOLATION_TO_TEXT[category]);

    return (
        <ViolationModal onClose={onClose} title={`${titleViolationText} Violation Detected`}>
            <TextP>
                {`Our moderation detected ${messageViolationText} violation and therefore disabled video generation.`}
                {hasTerms && violations ? (
                    <ViolationsParagraph>
                        <TextP>
                            Please review your content and ensure it does not violate any content restrictions around{' '}
                            {join(normalizedViolations)}.
                        </TextP>
                    </ViolationsParagraph>
                ) : (
                    <br />
                )}
                <ManualReview kind={violationType === 'audio' ? ERROR_KINDS.AudioModerationError : ERROR_KINDS.TextModerationError} />
            </TextP>
        </ViolationModal>
    );
}
